import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { coercedBooleanWithDefault } from '../../common/coerced-boolean'

export const cashFlowSummaryQuerySchema = z
  .object({
    currency: z.nativeEnum(Currency).optional(),
    accountId: z.string().guid().optional(),
    accountIds: z
      .preprocess(
        (v) => (typeof v === 'string' ? v.split(',').filter(Boolean) : v),
        z.array(z.string().guid()).min(1).max(50)
      )
      .optional(),
    year: z.coerce.number().int().min(2000).max(2100),
    showRecalculated: coercedBooleanWithDefault(false),
    showUnsettledShared: coercedBooleanWithDefault(false),
    showInternalTransfers: coercedBooleanWithDefault(true),
    showAccruedInterests: coercedBooleanWithDefault(true),
  })
  .refine((q) => q.accountId !== undefined || q.accountIds !== undefined, {
    message: 'either accountId or accountIds must be provided',
  })

export type CashFlowSummaryQueryDto = z.infer<typeof cashFlowSummaryQuerySchema>
